const SimpleChart = ({ data = [], series = [] }) => {
  if (!data.length || !series.length) {
    return (
      <div className="rounded-xl border border-dashed border-slate-200 bg-white p-6 text-sm text-slate-500 shadow-sm">
        No chart data yet.
      </div>
    );
  }

  const width = 640;
  const height = 240;
  const padding = 32;
  const innerWidth = width - padding * 2;
  const innerHeight = height - padding * 2;
  const maxVal = Math.max(
    ...series.flatMap((s) => data.map((d) => Number(d[s.key] || 0))),
    1
  );

  const pointsFor = (key) =>
    data.map((d, idx) => {
      const x = padding + (idx / Math.max(1, data.length - 1)) * innerWidth;
      const y = padding + innerHeight - (Number(d[key] || 0) / maxVal) * innerHeight;
      return `${idx === 0 ? 'M' : 'L'}${x},${y}`;
    });

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="mb-3 flex flex-wrap items-center gap-3 text-sm">
        {series.map((s) => (
          <div key={s.key} className="flex items-center gap-2 text-slate-700">
            <span className="h-2 w-6 rounded-full" style={{ backgroundColor: s.color || '#0ea5e9' }} />
            <span>{s.label}</span>
          </div>
        ))}
      </div>
      <svg viewBox={`0 0 ${width} ${height}`} className="h-56 w-full text-slate-400">
        <line x1={padding} x2={padding} y1={padding} y2={height - padding} stroke="currentColor" strokeWidth="1" />
        <line
          x1={padding}
          x2={width - padding}
          y1={height - padding}
          y2={height - padding}
          stroke="currentColor"
          strokeWidth="1"
        />
        {series.map((s) => (
          <path
            key={s.key}
            d={pointsFor(s.key).join(' ')}
            fill="none"
            stroke={s.color || '#0ea5e9'}
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        ))}
      </svg>
    </div>
  );
};

export default SimpleChart;
